import { useState } from "react";

import Api from "../services/Api";
import useAuth from "../routes/login/AuthContext";
import { LoadUserInfo } from "../services/UserApi";
import { useSnackbar } from "./useSnackbar";

// todo: REWRITE TO TS

export const useUserSearch = (l1Id, firstName, lastName, pin, globalSearch, userId) => {
  const { getAuthToken } = useAuth();
  const { showErrorSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [results, setResults] = useState({ results: [], searched: false });

  const submit = async () => {
    setIsLoading(true);

    let values = null;

    try {
      if (pin) {
        values = await Api.getUserSearchByPin(l1Id, pin, await getAuthToken());
      } else if (userId) {
        values = await LoadUserInfo(userId, await getAuthToken());
      } else {
        values = await Api.getUserSearchByName(l1Id, firstName, lastName, globalSearch, await getAuthToken());
      }

      if (userId) {
        const user = values.result;
        const modifiedValues = [{ ...user, id: user.uid, name: user.firstName + " " + user.lastName }];
        setResults({ results: modifiedValues, searched: true });
      } else {
        setResults({ results: values, searched: true });
      }
    } catch (error) {
      showErrorSnackbar(error.message);
    }

    setIsLoading(false);
  };

  function clearSearchResults() {
    setResults({ results: [], searched: false });
  }

  return {
    results,
    submit,
    isLoading,
    clearSearchResults,
  };
};
